import helpers from "../helpers/helpers";
export default {
  modelName: 'checklist_template',
  versionModelName: 'checklist_template_version',
  versionTimestampKey: 'created_at',
  label: '點檢表公版',
  fields: {
    id: {
      type: 'text',
      label: 'ID',
      readonly: true,
    },
    sequence: {
      type: 'text',
      label: '排序',
      maxlength: 10,
    },
    frequency: {
      type: 'select',
      label: '頻率',
      placeholder: '篩選頻率',
      items: [
        {
          text: '日',
          value: 'day',
        },
        {
          text: '週',
          value: 'week',
        },
        {
          text: '月',
          value: 'month',
        },
        {
          text: '季',
          value: 'season',
        },
        {
          text: "年",
          value: "year",
        },
        {
          text: "每次作業",
          value: "everyTime",
        },
      ],
      defaultValue: 'day',
    },
    status: {
      type: 'select',
      label: '',
      defaultValue: '0',
      items: [
        {
          text: '顯示',
          value: 1,
        },
        {
          text: '隱藏',
          value: 0,
        },
        {
          text: '修訂中',
          value: 2,
        },
      ],
    },
    // is_active: {
    //   type: 'switch',
    //   label: '顯示/隱藏',
    //   defaultValue: true,
    //   activeText: '顯示',
    //   inactiveText: '隱藏',
    // },
    last_version: {
      type: 'last_version',
      label: '版本列表',
      modelName: 'checklist_template_version',
      showFields: ['name_mainlocale', 'updated_at'],
      fields: {
        locales: {
          type: 'locales',
          // label: "多語言內容",
          fields: {
            name: {
              type: 'text',
              label: '點檢表名稱',
              rules: 'required',
              maxlength: 30,
            },
            remark: {
              type: 'text',
              label: '備註',
              maxlength: 1000,
            },
            // control_limit_suggest: {
            //   type: 'text',
            //   label: 'Control Limit (管制界線) 設定建議',
            //   maxlength: 1000,
            // },
            // spec_limit_suggest: {
            //   type: 'text',
            //   label: 'Spec Limit (合規界線) 設定建議',
            //   maxlength: 1000,
            // },
          },
        },
        updated_at: {
          type: 'datetime',
          label: '更新時間',
          readonly: true,
        },
        updated_admin: {
          type: 'belongsTo',
          label: '最後更新人',
          textKey: 'name',
          readonly: true,
        },
      },
    },
    locales: {
      type: 'locales',
      fields: {
        name: {
          type: 'text',
          label: '點檢表名稱',
          rules: 'required',
          maxlength: 30,
        },
        remark: {
          type: 'text',
          label: '備註',
          maxlength: 1000,
        },
      },
    },
    name: {
      type: 'text',
      label: '名稱',
      readonly: true,
    },
    areas: {
      label: '適用地區',
      type: 'multi-layer',
      rules: 'required',
      modelName: 'areas',
      getUrl: 'area',
      requiredField: 'area_sections',
      multiple: true,
      layersSetting: {
        modelName: 'area_sections',
        requiredFieldKey: 'area_sections',
        search: true,
      },
      getText: (data) => {
        let result = ""
        data.forEach((_data) => {
          if (result !== "") {
            result += ","
          }
          result += _data.name
        })
        return result
      },
      fields: {
        modelName: 'area',
        requiredField: 'area_sections',
        layersSetting: {
          modelName: 'area_sections',
          requiredFieldKey: 'area_sections',
          search: true,
        },
      }
    },
    area_sections: {
      label: '適用子地區',
      type: 'hasMany',
    },
    range_type: {
      type: 'select',
      label: '適用範圍類型',
      items: [
        {
          value: 'general',
          text: '通用',
        },
        {
          value: 'exclusive',
          text: '專屬',
        },
      ],
      defaultValue: 'general',
    },
    factories: {
      type: 'hasMany',
      label: '適用工廠',
      textKey: 'name',
      modelName: 'factory',
      requiredField: 'areas',
      conditionKeys: [
        {
          fieldName: 'areas',
          conditionName: 'area',
          type: 'array',
        },
      ],
      getText: (item) => {
        return helpers.methods.$_CMS_getFactoryName(item)
      },
      displayCheck: (modelData) => {
        if (modelData.range_type === "general") { 
          return true
        } else if(modelData.range_type === "exclusive") {
          return false
        }
      },
    },
    exclusive_factories: {
      type: 'hasMany',
      label: '專屬工廠',
      textKey: 'name',
      modelName: 'factory',
      requiredField: 'areas',
      conditionKeys: [
        {
          fieldName: 'areas',
          conditionName: 'area',
          type: 'array',
        },
      ],
      getText: (item) => {
        return helpers.methods.$_CMS_getFactoryName(item)
      },
      displayCheck: (modelData) => {
        if (modelData.range_type === "general") { 
          return false
        } else if(modelData.range_type === "exclusive") {
          return true
        }
      },
      getRules: (modelData) =>{
        if (modelData.range_type === "exclusive") {
          return "required"
        } else {
          return null
        }
      }
    },
    system_classes: {
      label: '領域',
      type: 'hasMany',
      textKey: 'name',
      clearable: true,
      modelName: 'system_class',
      requiredField: 'areas',
      rules: 'required',
      conditionKeys: [
        {
          fieldName: 'areas',
          conditionName: 'area',
          type: 'array',
        },
      ],
      getText(data) {
        return data.name
      }
    },
    system_subclasses: {
      conditionKeys: [
        {
          fieldName: 'system_classes',
          conditionName: 'system_class',
          type: 'array',
        },
      ],
      requiredField: 'system_classes',
      label: '子領域',
      type: 'hasMany',
      rules: 'required',
      textKey: 'name',
      modelName: 'system_subclass',
    },
    industry_categories: {
      label: '適用產業類別',
      type: 'multi-layer',
      modelName: 'industry_categories',
      getUrl: 'industry_category',
      multiple: true,
      conditionKeys: [
        {
          fieldName: 'areas',
          conditionName: 'area',
          type: 'array',
        },
      ],
      fields: {
        modelName: 'industry_categories',
        getUrl: 'industry_category',
        conditionKeys: [
          {
            fieldName: 'areas',
            conditionName: 'area',
            type: 'array',
          },
        ],
      }
    },
    updated_at: {
      type: 'datetime',
      label: '最後更新時間',
      readonly: true,
    },
    updated_admin: {
      type: 'belongsTo',
      label: '最後更新人',
      readonly: true,
      textKey: 'name',
      modeldataName: 'admin',
    },
    updated_info: {
      type: 'custom',
      label: '上次修改時間',
      getValue: (item) => {
        let _value = item.updated_at;
        if (item.updated_admin) {
          _value += `  ${item.updated_admin}`;
        }
        return _value;
      },
    },
    created_at: {
      type: 'datetime',
      label: '建立時間',
      readonly: true,
      textKey: 'name',
    },
    created_admin: {
      type: 'belongsTo',
      label: '建立者',
      readonly: true,
      textKey: 'name',
    },
  },
};
